/* eslint-disable complexity */
import { Pickable } from '@app/engine/core/interfaces';
import { html } from '@app/engine/utils/development/formatter';
import { ColorScheme } from './color-scheme';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class VelocityColorScheme extends ColorScheme {
    label = 'Velocity';
    id = 'VelocityColorScheme';
    static id = 'VelocityColorScheme';
    isOptionInRmbMenu = false;
    static uniqueObjectTypeFlags = {
        velocitySlow: true,
        velocityMed: true,
        velocityFast: true,
    };
    static uniqueColorTheme = {
        velocitySlow: [1.0, 0.0, 0.0, 1.0],
        velocityMed: [1.0, 0.5, 0.0, 1.0],
        velocityFast: [1.0, 1.0, 0.0, 1.0],
        deselected: [1.0, 1.0, 1.0, 1.0],
        inFOVAlt: [1.0, 1.0, 1.0, 1.0],
        selected: [1.0, 1.0, 1.0, 1.0],
        sensor: [1.0, 1.0, 1.0, 1.0],
    };
    constructor() {
        super(VelocityColorScheme.uniqueColorTheme);
        this.objectTypeFlags = {
            ...this.objectTypeFlags, ...VelocityColorScheme.uniqueObjectTypeFlags,
        };
    }
    update(obj) {
        if (obj.isStar()) {
            return this.starColor_(obj);
        }
        const checkFacility = this.checkFacility_(obj);
        if (checkFacility) {
            return checkFacility;
        }
        // Sensors
        if (obj.isSensor()) {
            return {
                color: this.colorTheme.sensor,
                pickable: Pickable.Yes,
            };
        }
        const dotsManagerInstance = ServiceLocator.getDotsManager();
        if (dotsManagerInstance.inViewData?.[obj.id] === 1) {
            if (this.objectTypeFlags.inViewAlt === false) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
            return {
                color: this.colorTheme.inFOVAlt,
                pickable: Pickable.Yes,
            };
        }
        if (obj.totalVelocity > 5.5 && this.objectTypeFlags.velocityFast === false) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        if (obj.totalVelocity >= 2.5 && obj.totalVelocity <= 5.5 && this.objectTypeFlags.velocityMed === false) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        if (obj.totalVelocity < 2.5 && this.objectTypeFlags.velocitySlow === false) {
            return {
                color: this.colorTheme.deselected,
                pickable: Pickable.No,
            };
        }
        return {
            color: [1.0 - Math.min(obj.totalVelocity / 15, 1.0), Math.min(obj.totalVelocity / 15, 1.0), 0.0, 1.0],
            pickable: Pickable.Yes,
        };
    }
    static layersHtml = html `
  <ul id="layers-list-velocity">
    <li>
      <div class="Square-Box layers-velocityFast-box"></div>
      ~7 km/s Velocity
    </li>
    <li>
      <div class="Square-Box layers-velocityMed-box"></div>
      ~4 km/s Velocity
    </li>
    <li>
      <div class="Square-Box layers-velocitySlow-box"></div>
      ~1 km/s Velocity
    </li>
  </ul>
  `.trim();
}
